const schedules = {
  key: "schedules",
  title: "Schedules",
  angle: 180,
  summary: "Automated schedule production.",
  releaseDate: "Early 2027",
  launch: "/",
  planStages: [
    {
      name: "Scoping documents",
      detail: [
        {
          text: "Concept feature",
          checked: true,
        },
        {
          text: "Business Systems Requirements Document (BSRD)",
          checked: false,
        },
        {
          text: "Functional Design Document (FDD)",
          checked: false,
        },
      ],
      completionDate: "Oct 26",
    },
    {
      name: "Development",
      detail: [
        {
          text: "Admin feature development & testing",
          checked: false,
        },
        {
          text: "Main feature development",
          checked: false,
        },
        {
          text: "Initial data entry (this is ongoing and will continue after initial release)",
          checked: false,
        },
        {
          text: "Development phase testing",
          checked: false,
        },
      ],
      completionDate: "Dec 26",
    },
    {
      name: "Testing & QA",
      detail: [
        {
          text: "Workflow documents production",
          checked: false,
        },
        {
          text: "Main feature testing",
          checked: false,
        },
        {
          text: "Training & support documentation production",
          checked: false,
        },
        {
          text: "Training and deployment",
          checked: false,
        },
      ],
      completionDate: "Apr 27",
    },
  ],
  points: [
    "Schedules synchronized with 3D-model and P&ID's",
    "Automated governance based on embedded data",
    "Improved efficiency and accuracy",
  ],
};

export default schedules;
